module.exports = __webpack_public_path__ + "jab/media/cancel.fe7498b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/cancel.svg
// module id = 1470
// module chunks = 0